<template>
    <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><polyline points="17 11 19 13 23 9"></polyline></svg>
</template>
<script>
export default {
    
}
</script>
<style scoped>
    .icon{
         stroke: currentColor;
         height:1rem;
        margin-top:-0.3rem;
        margin-right:0.4rem;
    }
</style>